import { render, staticRenderFns } from "./modal-pay-play.vue?vue&type=template&id=6bd6ae5e&scoped=true&"
import script from "./modal-pay-play.ts?vue&type=script&lang=ts&"
export * from "./modal-pay-play.ts?vue&type=script&lang=ts&"
import style0 from "./modal-pay-play.scss?vue&type=style&index=0&id=6bd6ae5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd6ae5e",
  null
  
)

component.options.__file = "modal-pay-play.vue"
export default component.exports